// src/Dashboard/pages/user/ArbitrageJudo/components/ArbitrageAccordion.jsx

import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

export default function ArbitrageAccordion({ title, children, defaultOpen }) {
  const [open, setOpen] = useState(!!defaultOpen);

  return (
    <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-950">
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left transition hover:bg-slate-50 dark:hover:bg-slate-900"
      >
        <span className="text-sm font-bold text-slate-950 dark:text-white">
          {title}
        </span>

        <span className="grid h-8 w-8 shrink-0 place-items-center rounded-xl bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300">
          {open ? <FaChevronUp /> : <FaChevronDown />}
        </span>
      </button>

      {open && (
        <div className="border-t border-slate-200 px-4 py-4 text-sm leading-7 text-slate-700 dark:border-slate-700 dark:text-slate-300">
          {children}
        </div>
      )}
    </div>
  );
}